import { FeedbackPage } from "@/pages/Feedback";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/feedback")({
  component: FeedbackPage,
});
